'use client';
import { jsxs, jsx } from 'react/jsx-runtime';
import { forwardRef } from 'react';

const FlagHtAsset = ({ width, height, ...props }, ref) => /* @__PURE__ */ jsxs(
  "svg",
  {
    viewBox: "0 0 28 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ...props,
    width,
    height,
    ref,
    "aria-hidden": true,
    ...props,
    children: [
      /* @__PURE__ */ jsx(
        "path",
        {
          d: "M-3.85982e-05 4.49643e-06L27.9999 0C27.9999 6 27.9999 14 27.9999 20C18.6666 20 9.33328 20 -5.46678e-05 20C-5.46678e-05 14 -0.000216527 6 -3.85982e-05 4.49643e-06Z",
          fill: "white"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M-6.5152e-05 9.33334H27.9999V0L-3.85982e-05 4.49643e-06L-6.5152e-05 9.33334Z",
          fill: "#112EBC"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M-5.46678e-05 20H27.9999V9.33334H-6.5152e-05L-5.46678e-05 20Z",
          fill: "#E3264A"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          d: "M9.33329 7.33335C9.33329 6.96516 9.63176 6.66668 9.99995 6.66668H18C18.3681 6.66668 18.6666 6.96516 18.6666 7.33335V14C18.6666 14.3682 18.3681 14.6667 18 14.6667H9.99995C9.63176 14.6667 9.33329 14.3682 9.33329 14V7.33335Z",
          fill: "#FBFBFB"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M9.33329 13.3333L11.4369 12.2815C11.8072 12.0964 12.2155 12 12.6295 12H15.3704C15.7844 12 16.1927 12.0964 16.563 12.2815L18.6666 13.3333V14.6667H9.33329V13.3333Z",
          fill: "#AABCAE"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M9.99995 13.7454V14H18V13.7454L16.2649 12.8778C15.9872 12.739 15.6809 12.6667 15.3704 12.6667H12.6295C12.319 12.6667 12.0128 12.739 11.735 12.8778L9.99995 13.7454ZM18.6666 13.3333L16.563 12.2815C16.1927 12.0964 15.7844 12 15.3704 12H12.6295C12.2155 12 11.8072 12.0964 11.4369 12.2815L9.33329 13.3333V14.6667H18.6666V13.3333Z",
          fill: "#366C14"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M14 12C15.1045 12 16 11.1046 16 10C16 8.89544 15.1045 8.00001 14 8.00001C12.8954 8.00001 12 8.89544 12 10C12 11.1046 12.8954 12 14 12Z",
          fill: "#D4B872"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M10.6666 11.3871C10.6666 10.8281 11.3132 10.5173 11.7498 10.8665L13.5835 12.3335C13.827 12.5283 14.1729 12.5283 14.4164 12.3335L16.2502 10.8665C16.6867 10.5173 17.3333 10.8281 17.3333 11.3871V12.6667C17.3333 13.0349 17.0348 13.3333 16.6666 13.3333H11.3333C10.9651 13.3333 10.6666 13.0349 10.6666 12.6667V11.3871Z",
          fill: "#C28321"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M12.9328 12.6667L11.3333 11.3871L11.3333 12.6667H12.9328ZM15.0671 12.6667H16.6666V11.3871L15.0671 12.6667ZM11.7498 10.8665C11.3132 10.5173 10.6666 10.8281 10.6666 11.3871V12.6667C10.6666 13.0349 10.9651 13.3333 11.3333 13.3333H16.6666C17.0348 13.3333 17.3333 13.0349 17.3333 12.6667V11.3871C17.3333 10.8281 16.6867 10.5173 16.2502 10.8665L14.4164 12.3335C14.1729 12.5283 13.827 12.5283 13.5835 12.3335L11.7498 10.8665Z",
          fill: "#0D3488"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M12.569 8.56905C12.359 8.35906 12.5077 8.00001 12.8047 8.00001H15.1952C15.4922 8.00001 15.6409 8.35906 15.4309 8.56905L14.2357 9.76431C14.1055 9.89449 13.8944 9.89449 13.7643 9.76431L12.569 8.56905Z",
          fill: "#216C30"
        }
      )
    ]
  }
);
const VpFlagHtAsset = forwardRef(FlagHtAsset);

export { VpFlagHtAsset as default };
